import React from 'react';
import { Grid, Typography } from '@material-ui/core';

import { AssetStatus } from 'ui';
import { truncateString } from 'helpers';
import { Asset } from 'hooks/useAssets/useAssets.types';

import { useStyles } from './AssetDetails.styles';

export const AssetDetails = ({ status, id, name }: Asset) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item xs={3}>
        <AssetStatus status={status} />
      </Grid>
      <Grid item xs={9}>
        <Typography className={classes.title}>{truncateString({ maxLength: 20, string: id })}</Typography>
        <Typography className={classes.subtitle}>{name}</Typography>
      </Grid>
    </Grid>
  );
};
